import React, { useState, useEffect, useCallback, useRef } from "react";
import { Link, useNavigate } from "react-router-dom";
import Header from "../components/Frontend/Header";
import Footer from "../components/Frontend/Footer";
import API from "../api.js";
import { setAlert } from "action/index.js";
import { store } from "store/index";
import SimpleReactValidator from "simple-react-validator";
import { Helmet } from "react-helmet";
import ReactGA from "react-ga";
import ReactPixel from "react-facebook-pixel";
import Frame1 from "../assets/images/public-pages/Frame1.svg"
import Frame2 from "../assets/images/public-pages/Frame2.svg"
import Frame3 from "../assets/images/public-pages/Frame3.svg"
import Frame4 from "../assets/images/public-pages/Frame4.svg"
import Frame5 from "../assets/images/public-pages/Frame5.svg";
import Frame6 from "../assets/images/public-pages/Frame6.svg";
import Frame7 from "../assets/images/public-pages/Frame7.svg";
import Frame8 from "../assets/images/public-pages/Frame8.svg";
import Frame9 from "../assets/images/public-pages/Frame9.svg";
import Frame10 from "../assets/images/public-pages/Frame10.svg";
import Frame11 from "../assets/images/public-pages/Frame11.svg";
import Frame12 from "../assets/images/public-pages/Frame12.svg";
import Frame13 from "../assets/images/public-pages/Frame13.svg";
import Frame14 from "../assets/images/public-pages/Frame14.svg";
import Frame15 from "../assets/images/public-pages/Frame15.svg";
import Frame16 from "../assets/images/public-pages/Frame16.svg";
import Frame17 from "../assets/images/public-pages/Frame17.svg";
import Frame18 from "../assets/images/public-pages/Frame18.svg";
import Frame19 from "../assets/images/public-pages/Frame19.svg";
import '../../public/css/new-app.css'
import ReusableHomePageSlider from "./ReusableHomePageSlider";
import SkillAreas from "components/PublicPagesReusable/SkillAreas";
import TestimonialSection from "components/PublicPagesReusable/TestimonialSection";
import FeatureSection from "components/PublicPagesReusable/FeatureSection";
import AiPower from "components/PublicPagesReusable/AiPowerSection";
import SplitSection from "components/PublicPagesReusable/SplitSection";
import QRCode from "react-qr-code";

const PTEAppNew = () => {
  const navigate = useNavigate();
  const validator = useRef(new SimpleReactValidator());
  const sliderRef = useRef(null);

  const [state, setState] = useState({
    name: "",
    email: "",
    phone: "",
    message: "",
    error: [],
    submit: false,
    flag: false,
    lockSubmit: false,
    homePage: false,
    list: [],
    sliderStyles: { marginLeft: "0px", width: "100%" },
  });

  const adjustSliderWidth = useCallback(() => {
    const container = document.querySelector(".container");
    const outerDiv = document.querySelector(".outer-wrapper");
    const slickList = document.querySelector(".slick-list");
    if (container && outerDiv && slickList) {
      const leftWidth = container.getBoundingClientRect().left;
      const rightWidth =
        outerDiv.getBoundingClientRect().right - window.innerWidth;
      setState((prev) => ({
        ...prev,
        sliderStyles: {
          marginLeft: `${leftWidth}px`,
          width: `calc(100vw - ${leftWidth}px + ${Math.abs(rightWidth)}px)`,
        },
      }));
    }
  }, []);

  useEffect(() => {
    adjustSliderWidth();
    window.addEventListener("resize", adjustSliderWidth);

    // Analytics and pixel initialization
    ReactGA.initialize("UA-157984080-1");
    ReactGA.pageview(window.location.pathname + window.location.search);
    
    // ReactPixel.init("197333187452630");
    // ReactPixel.pageView();

    return () => {
      window.removeEventListener("resize", adjustSliderWidth);
    };
  }, [adjustSliderWidth]);

  const handleChange = useCallback((event) => {
    const { name, value } = event.target;
    setState((prev) => ({ ...prev, [name]: value }));
  }, []);

  const submitForm = useCallback(() => {
    if (validator.current.allValid() && !state.lockSubmit) {
      setState((prev) => ({ ...prev, lockSubmit: true }));

      const json = {
        name: state.name,
        email: state.email,
        phone: state.phone,
        message: state.message,
      };

      API({
        method: "POST",
        url: "post/contact",
        data: json,
      })
        .then((data) => {
          setState((prev) => ({
            ...prev,
            submit: true,
            lockSubmit: false,
            name: "",
            email: "",
            phone: "",
            message: "",
            flag: true,
          }));

          store.dispatch(
            setAlert({
              flag: true,
              type: 1,
              message: data.data.response.message,
            })
          );
        })
        .catch(() => {
          setState((prev) => ({ ...prev, lockSubmit: false }));
        });
    } else {
      validator.current.showMessages();
      // force re-render to show validation messages
      setState((prev) => ({ ...prev }));
    }
  }, [state.lockSubmit, state.name, state.email, state.phone, state.message]);

  // Redirect after successful submission
  useEffect(() => {
    if (state.flag) {
      navigate("/thank-you", { replace: true });
    }
  }, [state.flag, navigate]);

  const pteSlider = {
    dots: true,
    arrows: true,
    speed: 500,
    slidesToShow: 6,
    slidesToScroll: 1,
    autoplay: false,
    autoplaySpeed: 2000,
    responsive: [
      { breakpoint: 992, settings: { slidesToShow: 5 } },
      { breakpoint: 768, settings: { slidesToShow: 4 } },
      { breakpoint: 576, settings: { slidesToShow: 2 } },
    ],
  };

  const CardsSlider = {
    dots: true,
    arrows: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    adaptiveHeight: true,
    autoplaySpeed: 5000,
  };


  const academySections = [
    {
      title: (
        <>
          PTE Complete Question Bank
        </>
      ),
      highlight: "8,000+ Practice Questions Covering All Exam Modules",
      features: [
        "All 22 PTE question types with detailed explanations",
        "Algorithm-based scoring that mirrors the real exam",
        "Updated templates designed to trigger maximum points",
      ],
      iconBg: "#F4EBFF",
      icon: (
        <svg
          width="64"
          height="64"
          viewBox="0 0 64 64"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <rect width="64" height="64" rx="32" fill="#48A75C" />

          <path
            d="M42.3318 22.6667C44.2216 25.2936 45.3346 28.5168 45.3346 32C45.3346 35.4831 44.2216 38.7063 42.3318 41.3333M36.995 26.6667C38.0495 28.1784 38.668 30.017 38.668 32C38.668 33.983 38.0495 35.8215 36.995 37.3333M28.8471 23.1542L24.6261 27.3751C24.3955 27.6057 24.2802 27.721 24.1457 27.8035C24.0264 27.8766 23.8963 27.9305 23.7603 27.9631C23.6068 28 23.4438 28 23.1176 28H20.8013C20.0546 28 19.6812 28 19.396 28.1453C19.1451 28.2731 18.9411 28.4771 18.8133 28.728C18.668 29.0132 18.668 29.3866 18.668 30.1333V33.8667C18.668 34.6134 18.668 34.9868 18.8133 35.272C18.9411 35.5229 19.1451 35.7268 19.396 35.8547C19.6812 36 20.0546 36 20.8013 36H23.1176C23.4438 36 23.6068 36 23.7603 36.0368C23.8963 36.0695 24.0264 36.1234 24.1457 36.1965C24.2802 36.2789 24.3955 36.3942 24.6261 36.6248L28.8471 40.8457C29.4182 41.4169 29.7038 41.7025 29.949 41.7218C30.1617 41.7385 30.3696 41.6524 30.5082 41.4901C30.668 41.3031 30.668 40.8992 30.668 40.0915V23.9085C30.668 23.1007 30.668 22.6968 30.5082 22.5098C30.3696 22.3476 30.1617 22.2614 29.949 22.2782C29.7038 22.2975 29.4182 22.5831 28.8471 23.1542Z"
            stroke="white"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      ),
      imageSrc: '/images/web-new-images/emojis/Updated/Core-first.png'
    },
    {
      title: (
        <>
          Realistic Practice Dialogues & Audio
        </>
      ),
      highlight: "Comprehensive Listening Practice",
      features: [
        "Authentic accent training with varied speaking speeds",
        "Real exam-style audio content",
        "Integrated scoring across all sections",
      ],
      iconBg: "#0286FF1F",
      icon: (
      <svg width="64" height="64" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect width="64" height="64" rx="32" fill="#48A75C"/>
      <path d="M42.6654 32V33.3333C42.6654 39.2244 37.8897 44 31.9987 44C26.1077 44 21.332 39.2244 21.332 33.3333V32M31.9987 38.6667C29.0532 38.6667 26.6654 36.2789 26.6654 33.3333V25.3333C26.6654 22.3878 29.0532 20 31.9987 20C34.9442 20 37.332 22.3878 37.332 25.3333V33.3333C37.332 36.2789 34.9442 38.6667 31.9987 38.6667Z" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
      </svg>
      ),
      imageSrc: '/images/web-new-images/emojis/Updated/Core-second.png'
    },
    {
      title: (
        <>
          Real-Time Exam Simulation
        </>
      ),
      highlight: "Mock Tests That Mirror the Actual Experience",
      features: [
        "Full-length scored mock tests with precise feedback",
        "AI-powered assessment matching real exam algorithms",
        "Comprehensive performance analytics",
      ],
      iconBg: "#FFB02C1F",
      icon: (
        <svg
          width="64"
          height="64"
          viewBox="0 0 64 64"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <rect width="64" height="64" rx="32" fill="#48A75C" />

          <path
            d="M42.3318 22.6667C44.2216 25.2936 45.3346 28.5168 45.3346 32C45.3346 35.4831 44.2216 38.7063 42.3318 41.3333M36.995 26.6667C38.0495 28.1784 38.668 30.017 38.668 32C38.668 33.983 38.0495 35.8215 36.995 37.3333M28.8471 23.1542L24.6261 27.3751C24.3955 27.6057 24.2802 27.721 24.1457 27.8035C24.0264 27.8766 23.8963 27.9305 23.7603 27.9631C23.6068 28 23.4438 28 23.1176 28H20.8013C20.0546 28 19.6812 28 19.396 28.1453C19.1451 28.2731 18.9411 28.4771 18.8133 28.728C18.668 29.0132 18.668 29.3866 18.668 30.1333V33.8667C18.668 34.6134 18.668 34.9868 18.8133 35.272C18.9411 35.5229 19.1451 35.7268 19.396 35.8547C19.6812 36 20.0546 36 20.8013 36H23.1176C23.4438 36 23.6068 36 23.7603 36.0368C23.8963 36.0695 24.0264 36.1234 24.1457 36.1965C24.2802 36.2789 24.3955 36.3942 24.6261 36.6248L28.8471 40.8457C29.4182 41.4169 29.7038 41.7025 29.949 41.7218C30.1617 41.7385 30.3696 41.6524 30.5082 41.4901C30.668 41.3031 30.668 40.8992 30.668 40.0915V23.9085C30.668 23.1007 30.668 22.6968 30.5082 22.5098C30.3696 22.3476 30.1617 22.2614 29.949 22.2782C29.7038 22.2975 29.4182 22.5831 28.8471 23.1542Z"
            stroke="white"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      ),
      imageSrc: '/images/web-new-images/emojis/Updated/Core-third.png'
    },
    {
      title: (
        <>
          Proven Success Strategies
        </>
      ),
      highlight: "Expert Tips for First-Attempt Success",
      features: [
        "Updated templates for all question types",
        "Section-specific strategies for maximum scores",
        "Real-time feedback on speaking and writing tasks",
      ],
      iconBg: "#94C23C1F",
      icon: (
        <svg width="64" height="64" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect width="64" height="64" rx="32" fill="#48A75C"/>
        <path d="M42.6654 32V33.3333C42.6654 39.2244 37.8897 44 31.9987 44C26.1077 44 21.332 39.2244 21.332 33.3333V32M31.9987 38.6667C29.0532 38.6667 26.6654 36.2789 26.6654 33.3333V25.3333C26.6654 22.3878 29.0532 20 31.9987 20C34.9442 20 37.332 22.3878 37.332 25.3333V33.3333C37.332 36.2789 34.9442 38.6667 31.9987 38.6667Z" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
      ),
      imageSrc: '/images/web-new-images/emojis/Updated/Core-four.png'
    },
    {
      title: (
        <>
          Seamless Mobile Experience
        </>
      ),
      highlight: "Study Anywhere, Anytime with Zero Compromise",
      features: [
        "Progress tracking across all devices",
        "Never miss a learning opportunity again",
      ],
      iconBg: "#FFB02C1F",
      icon: (
        <svg
          width="64"
          height="64"
          viewBox="0 0 64 64"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <rect width="64" height="64" rx="32" fill="#48A75C" />

          <path
            d="M42.3318 22.6667C44.2216 25.2936 45.3346 28.5168 45.3346 32C45.3346 35.4831 44.2216 38.7063 42.3318 41.3333M36.995 26.6667C38.0495 28.1784 38.668 30.017 38.668 32C38.668 33.983 38.0495 35.8215 36.995 37.3333M28.8471 23.1542L24.6261 27.3751C24.3955 27.6057 24.2802 27.721 24.1457 27.8035C24.0264 27.8766 23.8963 27.9305 23.7603 27.9631C23.6068 28 23.4438 28 23.1176 28H20.8013C20.0546 28 19.6812 28 19.396 28.1453C19.1451 28.2731 18.9411 28.4771 18.8133 28.728C18.668 29.0132 18.668 29.3866 18.668 30.1333V33.8667C18.668 34.6134 18.668 34.9868 18.8133 35.272C18.9411 35.5229 19.1451 35.7268 19.396 35.8547C19.6812 36 20.0546 36 20.8013 36H23.1176C23.4438 36 23.6068 36 23.7603 36.0368C23.8963 36.0695 24.0264 36.1234 24.1457 36.1965C24.2802 36.2789 24.3955 36.3942 24.6261 36.6248L28.8471 40.8457C29.4182 41.4169 29.7038 41.7025 29.949 41.7218C30.1617 41.7385 30.3696 41.6524 30.5082 41.4901C30.668 41.3031 30.668 40.8992 30.668 40.0915V23.9085C30.668 23.1007 30.668 22.6968 30.5082 22.5098C30.3696 22.3476 30.1617 22.2614 29.949 22.2782C29.7038 22.2975 29.4182 22.5831 28.8471 23.1542Z"
            stroke="white"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      ),
      imageSrc: '/images/web-new-images/emojis/Updated/Core-five.png'
    },
  ];

  const lifestyleCards = [
    {
      title: "Perfect For Commuters",
      text: "Transform your daily travel time into productive exam preparation. Practice NAATI CCL vocabulary or PTE speaking tasks during train rides, or review dialogues and templates while waiting.",
      color: "#48A75C",
      img: '/images/web-new-images/emojis/Updated/YellowGlobe.svg'
    },
    {
      title: "Ideal For Working Professionals",
      text: "Squeeze in focused practice sessions during lunch breaks, before meetings, or whenever you have 10-15 spare minutes. Switch between NAATI CCL and PTE preparation based on your priorities.",
      color: "#0286FF",
      img: '/images/web-new-images/emojis/Updated/RedGlobe.svg'
    },
    {
      title: "Essential For Students",
      text: "Balance your exam preparation with university commitments. Study efficiently for both NAATI CCL and PTE without compromising your academic schedule.",
      color: "#7F56D9",
      img: '/images/web-new-images/emojis/Updated/GreenGlobe.svg'
    },
    {
      title: "Complement To Classroom Learning",
      text: "Never fall behind even if you miss in-person classes. Access the same quality materials and exercises for both exams from anywhere.",
      color: "#FFB02C",
      img: '/images/web-new-images/emojis/Updated/BlueGlobe.svg'
    },
  ];
    const images = [{
      src: Frame1,
      alt: "score-1",
    },
    {
      src: Frame2,
      alt: "score-2",
    },
    {
      src: Frame3,
      alt: "score-3",
    },
    {
      src: Frame4,
      alt: "score-4",
    },
    {
      src: Frame5,
      alt: "score-5",
    },
    {
      src: Frame6,
      alt: "score-6",
    },{
      src: Frame7,
      alt: "score-7",
    },
    {
      src: Frame8,
      alt: "score-8",
    },
    {
      src: Frame9,
      alt: "score-9",
    },
    {
      src: Frame10,
      alt: "score-10",
    },
    {
      src: Frame11,
      alt: "score-11",
    },
    {
      src: Frame12,
      alt: "score-12",
    },
    {
      src: Frame13,
      alt: "score-13",
    },
    {
      src: Frame14,
      alt: "score-14",
    },{
      src: Frame15,
      alt: "score-15",
    },
    {
      src: Frame16,
      alt: "score-16",
    },
    {
      src: Frame17,
      alt: "score-17",
    },
    {
      src: Frame18,
      alt: "score-18",
    },
    {
      src: Frame19,
      alt: "score-19",
    }
];

const skillAreaTitle = () => {
    return (
   <p className="top-section-text FS56FW500 mb-4 white">
    Designed For Your <span className="text-success">Busy <br/> Lifestyle</span>
    </p>
    )
  }

    const sliderList = {
    title: "What Our <span>Students Say</span>",
    subtitle: "Real success stories from our learners",

    settings: {
      slidesToShow: 2.5,
      autoplay: true,
    },

    items: [
      {
        id: 1,
        name: "Anika Patel",
        location: "Tanahun, Nepal",
        description:
          "Got Band 7.5 on my first attempt after months of self-study going nowhere. The writing feedback was detailed and specific — that alone was worth the enrolment fee.",
        image: "/images/web-new-images/new-content-slider/SahidaKhatun-demo.svg",
      },
      {
        id: 2,
        name: "Yuki Tanaka",
        location: "Osaka, Japan",
        description:
          "Reading and listening were always my weak points. The targeted practice modules addressed both specifically. Went from 6.5 to 7.5 in those skills in about eight weeks.",
        image: "/images/web-new-images/new-content-slider/DilmeetKingra-demo.svg",
      },
      {
        id: 3,
        name: "Hassan Ibrahim",
        location: "Cairo, Egypt",
        description:
          "Writing Task 2 used to take me 45 minutes and I'd still get Band 6. After learning how to structure arguments properly I now finish with time to spare and consistently hit 7.5.",
        image: "/images/web-new-images/new-content-slider/SapnaPandey-demo.svg",
      },
      {
        id: 4,
        name: "Kwame Asante",
        location: "Kumasi, Ghana",
        description:
          "Grammar was always patchy for me. Teaching it in context rather than as abstract rules finally made things click. Got Band 7.5 in writing — first time I've ever been happy with that score.",
        image: "/images/web-new-images/new-content-slider/JayPatel-demo.svg",
      },
      {
        id: 5,
        name: "Sunita Thapa",
        location: "Kathmandu, Nepal",
        description:
          "Needed Band 7 for my visa. The coaches gave me a realistic four-week plan and I hit exactly that. Efficient, honest preparation — that's what I'd tell anyone considering this.",
        image: "/images/web-new-images/new-content-slider/RamimRahman-demo.svg",
      },
      {
        id: 6,
        name: "Harpreet Kaur",
        location: "Punjab, India",
        description:
          "Third time attempting IELTS. First two times I studied on my own. This time, proper coaching. Huge difference. Band 7 overall — my family visa application is now in progress.",
        image: "/images/web-new-images/new-content-slider/HamzaAghariya-demo.svg",
      },
    ]
  };

  const featureData = {
    title: "More Than Apps, They’re Your",
    highlightText: "Success Companions",
    bottomText: "This isn't just practice, it's precision preparation.",
    ctaText: "Start Your Precision Preparation",
    onCtaClick: () => window.location.href = '/auth/register',
    cards: [
      {
        icon: "/images/web-new-images/emojis/Updated/WhiteGlobe.svg",
        title: "Seamless Integration",
        description:
          "Works perfectly alongside our online classes and in-person coaching. Your progress syncs across all platforms for both NAATI CCL preparation.",
      },
      {
        icon: "/images/web-new-images/emojis/Updated/WhiteGlobe.svg",
        title: "Smart Progress Tracking",
        description:
          "Monitor your improvement across all vocabulary categories, dialogue types, and PTE question formats. See exactly where you need to focus for each exam.",
      },
      {
        icon: "/images/web-new-images/emojis/Updated/WhiteGlobe.svg",
        title: "Expert-Designed Content",
        description: "Every feature, dialogue, vocabulary list, and the template is crafted by certified professionals who understand both exams inside out.",
      },
      {
        icon: "/images/web-new-images/emojis/Updated/WhiteGlobe.svg",
        title: "Regular Updates",
        description: "Content is continuously updated based on recent exam patterns and feedback from successful students for both NAATI CC.",
      },
    ],
  };

  const spliteSectionData = {
    title: "The Bottom Line:",
    highlight: "Your Success is Mobile",
    quote: "Achieving high PTE scores isn't rocket science...",
    descriptions: [
      "We understand the life-changing value of those 5 points...",
      "Your dreams deserve expert preparation...",
    ],
    features: [
      "Busy schedule? Practice on your commute",
      "Missed a class? Access instantly",
      "Need quick review? Everything's in your pocket",
      "Multiple exams? Switch seamlessly",
      "Last-minute prep? Covered",
    ],
    buttonText: "Download Now And Transform Your Commute",
    onButtonClick: () => {
      window.open(import.meta.env.VITE_PTE_IOS_APP_URL, "_blank");
    },
    image: "/images/web-new-images/emojis/Updated/BottomLine.png",
    imagePosition: "left",
    bgColor: "#ffffff",
    textColor: "#000000",
  };
  return (
    <React.Fragment>
      <Helmet>
        <title>Language Academy</title>
        <meta name="twitter:title" content="Language Academy" />
        <meta property="og:title" content="Language Academy" />
      </Helmet>
      <Header />
      <main className="new-design">
        <div className="banner-section mt-0 noc-banner">
          <section
            className="naati-hero-section"
            style={{
              "--background-color":
                "linear-gradient(90deg, #eaf7e9 0%, #f4f4f4 100%)",
              "--text-color": "black",
            }}
          >
            <div className="container-fluid hero-new py-5">
              <div className="container">
                <div className="row justify-content-center text-center">
                  {/* Top Tag */}
                  <div className="col-12 mb-3">
                    <span className="students-stat mb-4">
                      Top PTE Training Institute, NAATI CCL & IELTS Prep.
                    </span>
                  </div>

                  {/* Heading */}
                  <div className="row">
                    {/* Left Stats */}
                    <div className="col-lg-2 text-center text-lg-start mb-4 mb-lg-0">
                      <h3 className="target FS40FW600 mb-0">1M+</h3>
                      <p className="downloads-text">Downloads</p>

                      <div className="avatars d-flex justify-content-center justify-content-lg-start">
                        <img
                          src="/images/web-new-images/emojis/Updated/followers1.jpg"
                          className="avatar rounded-circle"
                        />
                        <img
                          src="/images/web-new-images/emojis/Updated/followers2.jpg"
                          className="avatar rounded-circle ms-n3"
                        />
                        <img
                          src="/images/web-new-images/emojis/Updated/followers3.jpg"
                          className="avatar rounded-circle ms-n3"
                        />
                        <img
                          src="/images/web-new-images/emojis/Updated/followers4.jpg"
                          className="avatar rounded-circle ms-n3"
                        />
                        <span className="avatar-more">+</span>
                      </div>
                    </div>
                    <div className="col-lg-8">
                      <h1 className="hero-title mb-3">
                        Master <span className="text-success">PTE</span> From
                        Anywhere <br />
                        Best PTE Exam Practice App
                      </h1>

                      <p className="hero-subtitle mb-4">
                        The complete mobile solution that ensures your language
                        proficiency goals are always within reach, wherever life
                        takes you.
                      </p>

                      {/* CTA */}
                      <button className="primary-btn" onClick={() => window.open('https://apps.apple.com/us/app/la-pte/id6443614190')}>
                        Download Our App Today  <img src="/images/web-new-images/right-arrow.svg" alt="LA" />
                      </button>
                    </div>
                  </div>
                </div>

                {/* Bottom Section */}
                <div className="row align-items-end position-relative">
                  {/* Phones */}
                  <div className="text-center position-relative phones-wrapper bottom-images">
                    <img
                      src="/images/web-new-images/emojis/Updated/iPhone-Left.webp"
                      className="phone phone-left"
                      alt="Iphone Left"
                    />

                    <img
                      src="/images/web-new-images/emojis/Updated/iPhone-Center.webp"
                      className="phone phone-center"
                      alt="Iphone Center"
                    />

                    <img
                      src="/images/web-new-images/emojis/Updated/iPhone-Right.webp"
                      className="phone phone-right"
                      alt="Iphone Right"
                    />
                  </div>
                </div>
              </div>
            </div>
          </section>
          {/* Download Section */}
          <div style={{background:'#0D1830'}} className="mb-5">
            <section className="download-section custom-container" style={{'--background-color':'#0D1830','--text-color':'#fff'}}>
              <div className="download-container py-5">
                <div className="row align-items-center">
                  {/* Left Content */}
                  <div className="col-lg-6 mb-4 mb-lg-0">
                    <h2 className="top-section-text FS40FW600 F-600"> 
                      Download Our{" "}
                      <span className="text-success FS40FW600">
                        PTE App
                      </span>{" "}
                      Today!
                    </h2>

                    <p className="subtitle FS17FW500" style={{color:'#fff'}}>
                      Achieve your Australian permanent residency dreams and
                      global opportunities with our powerful mobile apps, designed
                      specifically for busy professionals, students, and
                      immigrants who need flexible, expert-level preparation for
                      NAATI CCL exams.
                    </p>

                    <button className="primary-btn" type="button" onClick={()=>{console.log('Btn Click')}}>
                      Download Our App Today{" "}
                      <img
                        src="/images/web-new-images/right-arrow.svg"
                        alt="Register Now"
                      />
                    </button>
                  </div>

                  {/* Right Cards */}
                  <div className="col-lg-6">
                    <div className="row g-4">
                      {/* iOS Card */}
                      <div className="col-md-6">
                        <div className="download-card FS40FW600" style={{'--background-color':'#132448','--text-color':'white'}}>
                          <p>
                            For <span>iOS</span>
                          </p>
                          <p className="subtitle FS16FW500" style={{'--text-color':'white'}}>iOS 26.3</p>

                          <button className="primary-btn" onClick={() => window.open(import.meta.env.VITE_PTE_IOS_APP_URL)}>
                            Download Now{" "}
                            <img
                              src="/images/web-new-images/right-arrow.svg"
                              alt="Register Now"
                            />
                          </button>

                          <div className="card-footer d-flex justify-content-between align-items-center mt-4">
                            {import.meta.env.VITE_PTE_IOS_APP_URL ? 
                              <QRCode value={`${import.meta.env.VITE_PTE_IOS_APP_URL}`} className="qr"/> :
                              <img src="/images/web-new-images/emojis/Updated/sample-qr.svg" alt="QR" className="qr" />
                            }

                            <div className="circle-wrapper" style={{'--background-color':'#0D1830'}}>
                              <div className="circle-inner" style={{'--background-color':'#132448'}}>
                                <img
                                  src="/images/web-new-images/emojis/Updated/Apple-white.png"
                                  alt="IOS"
                                  className="device-icon"
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>

                      {/* Android Card */}
                      <div className="col-md-6">
                        <div className="download-card FS40FW600" style={{'--background-color':'#132448','--text-color':'white'}}>
                          <p>
                            For <span>Android</span>
                          </p>
                          <p className="subtitle FS16FW500" style={{'--text-color':'white'}}>Android 16</p>

                          <button className="primary-btn" onClick={() => window.open(import.meta.env.VITE_PTE_ANDROID_APP_URL)}>
                            Download Now{" "}
                            <img
                              src="/images/web-new-images/right-arrow.svg"
                              alt="Register Now"
                            />
                          </button>

                          <div className="card-footer d-flex justify-content-between align-items-center mt-4">
                            {import.meta.env.VITE_PTE_ANDROID_APP_URL ? 
                            <QRCode value={`${import.meta.env.VITE_PTE_ANDROID_APP_URL}`} className="qr"/> :
                            <img src="/images/web-new-images/emojis/Updated/sample-qr.svg" alt="QR" className="qr" />
                            }

                            <div className="circle-wrapper" style={{'--background-color':'#0D1830'}}>
                              <div className="circle-inner" style={{'--background-color':'#132448'}}>
                                <img
                                  src="/images/web-new-images/emojis/Updated/Android-white.png"
                                  alt="Android"
                                  className="device-icon"
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </section>
          </div>
          <div className="card-wrapper">
            <ReusableHomePageSlider images={images} />
          </div>
        </div>
        {/* Old code */}

        <div className="custom-container success-section py-5">
          <div className="align-items-center justify-content-between row">
            {/* LEFT CONTENT */}
            <div className="col-lg-6 mb-4 mb-lg-0">
              <h1 className="hero-title FS40FW600">
                How Language Academy <span className="text-success">Apps</span>
                <br />
                <span className="text-success">Increase</span> Chances For
                Success
              </h1>

              <div className="quote-box FS18FW400 mt-3">
                Missing classes due to work commitments? Stuck in traffic during
                your commute? Have a few spare minutes between meetings?
              </div>

              <p className="mt-3 FS17W500">
                Your PTE preparation never has to stop.
              </p>

              <p className="FS17W500">
                Our mobile apps deliver the same expert-level training that has
                helped 50,000+ students achieve their goals, now optimized for
                your smartphone and available 24/7.
              </p>

              <button className="primary-btn mt-3" onClick={() => window.open(import.meta.env.VITE_PTE_IOS_APP_URL)}>
                Start Your Mobile Mastery{" "}
                <img
                  src="/images/web-new-images/right-arrow.svg"
                  alt="Register Now"
                />
              </button>
            </div>

            {/* RIGHT IMAGE SECTION */}
            <div className="col-lg-6">
              <img
                src="/images/web-new-images/emojis/Updated/PTE-success.png"
                alt="mobile1"
              />
            </div>
          </div>
        </div>

        <div className="pc-why-choose np-need-crack">
          <div className="custom-container">
            <section className="academy-section py-5">
              <div className="custom-container">
                <div className="hero-title FS40FW600 text-center mb-5">
                  Everything You Need{" "}
                  <span className="text-success">
                    To Crack PTE Core <br></br> & Academic
                  </span>{" "}
                  In Your Pocket
                </div>

                {academySections.map((section, index) => {
                  const imageLeft = index % 2 === 0;
                  return (
                    <div className="row align-items-center mb-5" key={index}>
                      <div
                        className={`col-lg-6 col-md-12 mb-4 mb-lg-0 ${
                          imageLeft ? "" : "order-lg-2"
                        }`}
                      >
                        <div className="academy-app-preview text-center">
                          <img
                            src={section.imageSrc}
                            className="img-fluid"
                            alt="app preview"
                          />
                        </div>
                      </div>
                      <div
                        className={`col-lg-6 col-md-12 ${
                          imageLeft ? "" : "order-lg-1"
                        }`}
                      >
                        <div
                          className="academy-sound-icon"
                          style={{ background: section.iconBg }}
                        >
                          {section.icon}
                        </div>

                        <h3 className="academy-subtitle">{section.title}</h3>

                        <div className="academy-highlight-box FS16FW500 mt-3 mb-4">
                          {section.highlight}
                        </div>

                        <ul className="feature-list">
                          {section.features.map((feature, i) => (
                            <li key={i} className="FS18FW400">
                              {feature}
                            </li>
                          ))}
                        </ul>
                      </div>
                    </div>
                  );
                })}
              </div>
              <div className="text-center">
                <button className="primary-btn" onClick={() => window.open(import.meta.env.VITE_PTE_IOS_APP_URL)}>
                  Experience The Full Power Of Mobile Learning
                </button>
              </div>
            </section>
          </div>
        </div>
        <SkillAreas
          skillAreaTitle={skillAreaTitle}
          lifestyleCards={lifestyleCards}
          leftSection={false}
          className={
            "text-center d-flex flex-column align-items-center justify-content-center"
          }
          skillBottomtitle={"Your schedule doesn't have to limit your success."}
          btnText2={"Get Instant Access"}
        />

        <div className="master-aspect-section ap-minute-count mt-5">
          <div className="custom-container">
            <div className="row">
              <h2 className="hero-title FS40FW600 text-center">
                The{" "}
                <span className="text-success FS40FW600">
                  5-Point Difference & Global Opportunities:
                </span>
                <br />
                Why Every Minute Counts
              </h2>
              <div className="master-cards">
                <div className="master-card">
                  <h2 className="card-title">
                    <span className="top-section">PTE</span> <br />
                    <span className="FS20FW500">Global Recognition</span>
                  </h2>
                  <ul className="feature-list">
                    <li className="FS18FW400">
                      <p>
                        Accepted by universities and immigration authorities worldwide
                      </p>
                    </li>
                    <li className="FS18FW400">
                      <p>
                        Fast 24-hour results for urgent applications
                      </p>
                    </li>
                    <li className="FS18FW400">
                      <p>AI-powered scoring ensures consistent, unbiased evaluation</p>
                    </li>
                  </ul>
                </div>
                <div className="master-card card2">
                  <h2 className="card-title">
                    <span className="top-section">Preparation Time</span> <br />
                    <span className="FS20FW500"> Maximize Your Potential</span>
                  </h2>
                  <ul className="feature-list">
                    <li className="FS18FW400">
                      <p>
                        Every minute matters when preparing for such important
                        exams
                      </p>
                    </li>
                    <li className="FS18FW400">
                      <p>
                        Consistent daily practice beats intensive cramming
                        sessions
                      </p>
                    </li>
                    <li className="FS18FW400">
                      <p>Mobile accessibility means no wasted opportunities</p>
                    </li>
                  </ul>
                </div>
              </div>
              <div className="text-center">
                <p className="sub-heading">
                  Don't let a busy schedule cost you your future opportunities.
                </p>
                <Link to="/auth/register" className="primary-btn">
                  Secure Your Success Today
                  <img
                    src="/images/web-new-images/right-arrow.svg"
                    alt="Register Now"
                  />
                </Link>
              </div>
            </div>
          </div>
        </div>

        <AiPower />

        <div className="all-language-section language-support mt-4">
          <div className="custom-container">
            <div className="row">
              <h2 className="hero-title FS40FW600 text-center mb-md-0">
                Comprehensive{" "}
                <span className="text-success FS40FW600">Language Support</span>
              </h2>
            </div>
            <div className="all-language-content">
              <div className="all-lang-cards text-center plus-sans">
                <h2 className="FS20FW500 fw-600">PTE PREPARATION FOR GLOBAL SUCCESS</h2>
                  <p className="FS18FW400">
                    Complete preparation materials for PTE Academic and PTE Core, accepted by institutions and immigration<br/> authorities worldwide.
                    <br />
                    <br />
                    Complete vocabulary translations, cultural context, and practice materials in your native language for NAATI CCL, plus comprehensive PTE preparation for international opportunities.
                  </p>
              </div>
              {/* <div className="all-lang-card">
                        <h2 className="title">PTE PREPARATION FOR GLOBAL SUCCESS</h2>
                        <p>
                          Complete preparation materials for PTE Academic and PTE Core, accepted by institutions and immigration authorities worldwide.
                          <br />
                          <br />
                          Complete vocabulary translations, cultural context, and practice materials in your native language for NAATI CCL, plus comprehensive PTE preparation for international opportunities.
                        </p>
                      </div> */}
            </div>
            <div className="text-center">
              <Link to="/auth/register" className="primary-btn dark-border">
                Find Your Preparation Path
                <img
                  src="/images/web-new-images/right-arrow.svg"
                  alt="Register Now"
                />
              </Link>
            </div>
          </div>
        </div>

        <div className="sss-section">
          {/* <CrackedCodeSlider title={`<span className="hero-title FS40FW600 text-center mb-md-0">What Our App <br/> <span className="text-success FS40FW600">Users Says</span></span>`} />
                  <div className="container">
                    <div className="text-center d-none">              
                      <Link to="#" className="primary-btn">
                        JOIN THOUSANDS OF SUCCESSFUL APP USERS
                        <img
                          src="/images/web-new-images/right-arrow.svg"
                          alt="Register Now"
                        />
                      </Link>
                    </div>
                  </div> */}
          <TestimonialSection
            title={`<span class="hero-title FS40FW600 text-center mb-md-0">What Our App <br/> <span class="green-text">Users Says</span></span>`}
            btnText="Join Thousands of Successful App Users"
            btnLink="/auth/register"
            sliderList={sliderList}
          />
        </div>

        <div className="naati-mobile-app vc-blue-section d-none">
          <div className="container">
            <div className="row text-center mt-0">
              <div className="">
                <h2 className="primary-heading fw-700 mb-0">
                  MORE THAN APPS,
                  <br className="d-none d-md-block" />
                  THEY'RE YOUR
                  <br className="d-block" />
                  <span className="wpl-badge text-white">
                    SUCCESS COMPANIONS
                  </span>
                </h2>
              </div>
              <div className="d-none">
                <div className="why-most-list">
                  <ul>
                    <li className="list7">
                      <span className="list-counting">
                        <svg
                          width="30"
                          height="30"
                          viewBox="0 0 30 30"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M2.55469 17.5546C2.55469 17.5546 2.70566 18.6114 7.07954 22.9853C11.4534 27.3592 18.5449 27.3592 22.9187 22.9853C24.4684 21.4356 25.469 19.5448 25.9206 17.5546M2.55469 17.5546V25.0213M2.55469 17.5546H10.0214M27.4436 12.5768C27.4436 12.5768 27.2926 11.52 22.9187 7.14613C18.5449 2.77225 11.4534 2.77225 7.07954 7.14613C5.52986 8.6958 4.52924 10.5866 4.07767 12.5768M27.4436 12.5768V5.11017M27.4436 12.5768H19.9769"
                            stroke="#FFB02C"
                            strokeWidth="1.86667"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                        </svg>
                      </span>
                      <div>
                        <h3>SEAMLESS INTEGRATION</h3>
                        <p>
                          Works perfectly alongside our online classes and
                          in-person coaching. Your progress syncs across all
                          platforms for both NAATI CCL and PTE preparation.
                        </p>
                      </div>
                    </li>
                    <li className="list3">
                      <span className="list-counting">
                        <svg
                          width="30"
                          height="30"
                          viewBox="0 0 30 30"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M14.9991 26.2657L14.8746 26.079C14.0102 24.7823 13.578 24.134 13.0069 23.6646C12.5014 23.2491 11.9188 22.9373 11.2927 22.7472C10.5854 22.5324 9.8062 22.5324 8.2478 22.5324H6.53691C5.143 22.5324 4.44605 22.5324 3.91364 22.2611C3.44533 22.0225 3.06458 21.6417 2.82596 21.1734C2.55469 20.641 2.55469 19.9441 2.55469 18.5502V7.84794C2.55469 6.45404 2.55469 5.75708 2.82596 5.22468C3.06458 4.75637 3.44533 4.37561 3.91364 4.137C4.44605 3.86572 5.143 3.86572 6.53691 3.86572H7.03469C9.82251 3.86572 11.2164 3.86572 12.2812 4.40827C13.2178 4.8855 13.9794 5.64701 14.4566 6.58364C14.9991 7.64844 14.9991 9.04235 14.9991 11.8302M14.9991 26.2657V11.8302M14.9991 26.2657L15.1236 26.079C15.9881 24.7823 16.4203 24.134 16.9914 23.6646C17.4969 23.2491 18.0794 22.9373 18.7056 22.7472C19.4129 22.5324 20.1921 22.5324 21.7505 22.5324H23.4614C24.8553 22.5324 25.5522 22.5324 26.0846 22.2611C26.5529 22.0225 26.9337 21.6417 27.1723 21.1734C27.4436 20.641 27.4436 19.9441 27.4436 18.5502V7.84794C27.4436 6.45404 27.4436 5.75708 27.1723 5.22468C26.9337 4.75637 26.5529 4.37561 26.0846 4.137C25.5522 3.86572 24.8553 3.86572 23.4614 3.86572H22.9636C20.1758 3.86572 18.7819 3.86572 17.717 4.40827C16.7804 4.8855 16.0189 5.64701 15.5417 6.58364C14.9991 7.64844 14.9991 9.04235 14.9991 11.8302"
                            stroke="#48A75C"
                            strokeWidth="1.86667"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                        </svg>
                      </span>
                      <div>
                        <h3>SMART PROGRESS TRACKING</h3>
                        <p>
                          Monitor your improvement across all vocabulary
                          categories, dialogue types, and PTE question formats.
                          See exactly where you need to focus for each exam.
                        </p>
                      </div>
                    </li>
                    <li className="list6">
                      <span className="list-counting">
                        <svg
                          width="30"
                          height="30"
                          viewBox="0 0 30 30"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M6.28802 12.577V20.0575C6.28802 20.5042 6.28802 20.7276 6.35604 20.9248C6.41618 21.0991 6.51434 21.258 6.64341 21.3897C6.78936 21.5388 6.98914 21.6386 7.38868 21.8384L14.1087 25.1984C14.4352 25.3617 14.5984 25.4433 14.7697 25.4754C14.9213 25.5039 15.0769 25.5039 15.2286 25.4754C15.3998 25.4433 15.5631 25.3617 15.8896 25.1984L22.6096 21.8384C23.0091 21.6386 23.2089 21.5388 23.3549 21.3897C23.4839 21.258 23.5821 21.0991 23.6422 20.9248C23.7102 20.7276 23.7102 20.5042 23.7102 20.0575V12.577M2.55469 10.7103L14.5539 4.71069C14.7172 4.62907 14.7988 4.58826 14.8844 4.57219C14.9602 4.55797 15.038 4.55797 15.1139 4.57219C15.1995 4.58826 15.2811 4.62907 15.4444 4.71069L27.4436 10.7103L15.4444 16.7099C15.2811 16.7915 15.1995 16.8324 15.1139 16.8484C15.038 16.8626 14.9602 16.8626 14.8844 16.8484C14.7988 16.8324 14.7172 16.7915 14.5539 16.7099L2.55469 10.7103Z"
                            stroke="#0286FF"
                            strokeWidth="1.86667"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                        </svg>
                      </span>
                      <div>
                        <h3>EXPERT-DESIGNED CONTENT</h3>
                        <p>
                          Every feature, dialogue, vocabulary list, and PTE
                          template is crafted by certified professionals who
                          understand both exams inside out.
                        </p>
                      </div>
                    </li>
                    <li className="list7">
                      <span className="list-counting">
                        <svg
                          width="30"
                          height="30"
                          viewBox="0 0 30 30"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M26.1991 12.5768C26.1991 12.5768 23.704 9.17728 21.677 7.14887C19.65 5.12046 16.8489 3.86572 13.7547 3.86572C7.5691 3.86572 2.55469 8.88013 2.55469 15.0657C2.55469 21.2513 7.5691 26.2657 13.7547 26.2657C18.8608 26.2657 23.1688 22.8488 24.5169 18.1768M26.1991 12.5768V5.11017M26.1991 12.5768H18.7325"
                            stroke="#FFB02C"
                            strokeWidth="1.86667"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                        </svg>
                      </span>
                      <div>
                        <h3>REGULAR UPDATES</h3>
                        <p>
                          Content is continuously updated based on recent exam
                          patterns and feedback from successful students for
                          both NAATI CCL and PTE.
                        </p>
                      </div>
                    </li>
                  </ul>
                </div>
              </div>
              <div className="text-center">
                <p className="sub-title my-4 text-center ">
                  This isn't just practice, it's precision preparation.
                </p>
                <div className="text-center ">
                  <Link className="primary-btn" to="/auth/register">
                    <span className="btn-inner">
                      Start Your Precision Preparation
                      <img
                        src="/images/web-new-images/right-arrow.svg"
                        alt="Register Now"
                      />
                    </span>
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
        <FeatureSection {...featureData} />
        <div className="bottom-line-section">
          <div className="custom-container">
            <div className="row align-items-center d-none">
              {/* LEFT IMAGE */}
              <div className="col-lg-6">
                <div className="">
                  <img
                    src="/images/web-new-images/emojis/Updated/BottomLine.png"
                    alt="app preview"
                    className=""
                  />
                </div>
              </div>

              {/* RIGHT CONTENT */}
              <div className="col-lg-6">
                <div className="content-wrapper">
                  <h2 className="hero-title FS40FW600 mb-md-0">
                    The Bottom Line: <br />
                    <span className="text-success FS40FW600">
                      Your Success is Mobile
                    </span>
                  </h2>
                  <div className="quote-box FS18FW400">
                    <p>
                      Achieving high PTE scores isn't rocket science, but it does require smart, consistent preparation.
                    </p>
                  </div>

                  <p className="desc">
                    We understand the life-changing value of those 5 points for Australian permanent residency and the global opportunities that come with strong PTE scores. That's why we've created the most comprehensive, convenient, and effective language exam preparation apps available.
                  </p>

                  <p className="desc">
                    Your dreams deserve expert preparation, now available
                    wherever you are.
                  </p>

                  {/* LIST */}
                  <ul className="feature-list">
                    <li>Busy schedule? Practice on your commute</li>
                    <li>Missed a class? Access the same materials instantly</li>
                    <li>Need quick review? Everything's in your pocket</li>
                    <li>Multiple exams to prepare for? Switch seamlessly</li>
                    <li>
                      Exam tomorrow? Last-minute packages have you covered
                    </li>
                  </ul>

                  {/* BUTTON */}
                  <div className="btn-wrapper">
                    <button className="primary-btn" onClick={() => window.open(import.meta.env.VITE_PTE_ANDROID_APP_URL)}>
                      Download Now And Transform Your Commute Into Exam Success{" "}
                      <img
                        src="/images/web-new-images/right-arrow.svg"
                        alt="Register Now"
                      />
                    </button>
                  </div>
                </div>
              </div>
            </div>
            <SplitSection {...spliteSectionData} />
          </div>
        </div>

        <section className="naati-hero-section bottom-section-radius custom-container">
          <div className="px-3 px-md-4 px-lg-5 hero-container py-5">
            <div className="row align-items-center g-5">
              {/* Left side - Text + Stats */}
              <div className="col-lg-6 text-center text-lg-start">
                <p className="top-section-text FS56FW500 mb-4">
                  Ready To Secure{" "}
                  <span className="text-success FS40FW600">Your Success</span>
                </p>

                <p className="lead-text FS20FW500 mb-4">
                  Don't let a busy lifestyle delay your Australian permanent
                  residency dreams or global opportunities.
                </p>
                <p className="lead-text FS20FW500 mb-4">
                  Download the Language Academy apps today and join thousands of
                  successful students who've earned their goals through smart,
                  flexible preparation.
                </p>

                <div className="download-buttons mb-5 d-flex flex-wrap justify-content-center justify-content-lg-start gap-3">
                  <a className="downlaod-btn" target="_blank" rel="noopener noreferrer" href={import.meta.env.VITE_PTE_ANDROID_APP_URL}>
                    <img
                      src="/images/web-new-images/google-play-01.svg"
                      alt="Register Now"
                    />
                  </a>
                  <a className="downlaod-btn" target="_blank" rel="noopener noreferrer" href={import.meta.env.VITE_PTE_IOS_APP_URL}>
                    <img
                      src="/images/web-new-images/app-store-01.svg"
                      alt="Register Now"
                    />
                  </a>
                </div>

                <div className="join-community d-flex align-items-center justify-content-center justify-content-lg-start gap-3">
                  <div className="avatars d-flex">
                    <img
                      src="/images/web-new-images/emojis/Updated/followers1.jpg"
                      alt="user"
                      className="avatar rounded-circle"
                    />
                    <img
                      src="/images/web-new-images/emojis/Updated/followers2.jpg"
                      alt="user"
                      className="avatar rounded-circle ms-n3"
                    />
                    <img
                      src="/images/web-new-images/emojis/Updated/followers3.jpg"
                      alt="user"
                      className="avatar rounded-circle ms-n3"
                    />
                    <img
                      src="/images/web-new-images/emojis/Updated/followers4.jpg"
                      alt="user"
                      className="avatar rounded-circle ms-n3"
                    />
                  </div>
                  <span className="join-text FS20FW500 F-600">
                    Join 10,000+ Students
                  </span>
                </div>
              </div>

              {/* Right side - Phones mockup */}
              <div className="col-lg-6">
                <div className="phones-container position-relative text-center">
                  <img
                    src="/images/web-new-images/emojis/Updated/new-iphone-dashboard.webp"
                    alt="NAATI CCL App - Mock Test"
                    className="img-fluid"
                  />
                </div>
              </div>
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </React.Fragment>
  );
};

export default PTEAppNew;